const section = document.querySelector(".worlds-first.has-image");
const bg = document.querySelector(".worlds-first-image");

if (section && bg) {

  let current = 500;
  let target = 500;

  function updateParallax() {

    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight;

    // Start animation when section enters viewport
    const start = vh * 0.8;

    // End when section is half out
    const end = -(rect.height * 0.5);

    // Initial offset
    const initialOffset = 400;

    // Total movement distance
    const parallaxDistance = 400;

    // Calculate progress
    let progress = (start - rect.top) / (start - end);

    // Clamp between 0 and 1
    progress = Math.max(0, Math.min(progress, 1));

    // Set target position
    target = initialOffset - (progress * parallaxDistance);
  }

  function animate() {

    // Smooth easing
    current += (target - current) * 0.08;

    bg.style.transform = `translate3d(0, ${current}px, 0)`;

    requestAnimationFrame(animate);
  }

  window.addEventListener("scroll", updateParallax);
  window.addEventListener("resize", updateParallax);

  updateParallax();
  animate();
}

document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll(".worlds-first-video video");

  videos.forEach((video) => {

    // Required for iPhone autoplay
    video.muted = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");

    // Try autoplay
    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // autoplay started
        })
        .catch(() => {

          // Retry after user interaction
          const startVideo = () => {
            video.play();

            document.removeEventListener("touchstart", startVideo);
            document.removeEventListener("click", startVideo);
          };

          document.addEventListener("touchstart", startVideo, {
            once: true
          });

          document.addEventListener("click", startVideo, {
            once: true
          });
        });
    }

  });

});